import finalita from "./finalita.json";
import nazioni from "./nazioni.json";
import province from "./province.json";
import tipo_tasso from "./tipo_tasso.json";

export const labelTipoPageHpTemplate = {
  HP: "Mutui",
  APC: "Under 36",
  SUR: "Surroga",
};

export const labels = {
  labelTipoPageHpTemplate: labelTipoPageHpTemplate,
  tipoTasso: tipo_tasso,
  finalita: finalita,
  province: province,
  nazioni: nazioni,
};
